import { orderBy, split, has, get, toLower } from 'lodash/fp';

const NumericFields = {
  id: true,
  price: true,
  weight: true,
  quantity: true,
  household_total: true
};

const isNumericField = field => has(field, NumericFields);

export default (order, list) => {
  const [sortBy, sortOrder] = split(':', order);
  return orderBy(
    each =>
      isNumericField(sortBy)
        ? parseFloat(get(sortBy, each))
        : toLower(get(sortBy, each)),
    sortOrder,
    list
  );
};
